import ContentJoin from "@/components/Shared/ContentJoin";
import Vector from "@/assets/team/vector-join.svg";

export default function TeamJoinSection() {
  return (
    <div className="py-[95px] relative">
      <Vector className="absolute right-[-100px] lg:top-[-450px] md:top-[-350px] " />
      <ContentJoin
        content={{
          title: "Interested in joining the Lawrence Harvey team?",
          info: ` Join us at Lawrence Harvey and be part of our dynamic team, where your passion for technology meets rewarding opportunities in tech recruitment. Whether you're an experienced professional seeking new challenges or looking to kick-start your career, we're looking for individuals who share our commitment to excellence and innovation. Explore our current openings today and take the next step towards a fulfilling career with Lawrence Harvey.`,
        }}
        button={{ btn: "Join us", link: "/join-us" }}
        path="team"
      />
    </div>
  );
}
